module.exports = __webpack_public_path__ + "static/media/10x10-rubber.66e2c099.png";